import React from 'react';

import DeleteBtn from '../Base/DeleteBtn';

import { ISpace } from '../../../../types/space';
import { ElementTypes } from '../../../../types/element';

interface IProps {
  space: ISpace<ElementTypes>;
}

class EditFormFieldNull extends React.PureComponent<IProps> {
  public render() {
    return <DeleteBtn />;
  }
}

export default EditFormFieldNull;
